export const queryKeys = {
  CONTROL_PERMISSIONS: 'CONTROL_PERMISSIONS',
  GET_ROLES: 'GET_ROLES',
  PERMISSION_STATE: 'PERMISSION_STATE'
};
